import React, { useState, useEffect } from "react";
import Tooltip from "@material-ui/core/Tooltip";

function ConfirmationDialog({ isOpen, onConfirm, onCancel, ticker }) {
  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onCancel();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <h3>Confirm Deletion</h3>
        <p>Are you sure you want to remove {ticker} from your watchlist?</p>
        <div className="confirmation-actions">
          <button className="btn btn-secondary" onClick={onCancel}>Cancel</button>
          <button className="btn btn-danger" onClick={onConfirm}>Remove</button>
        </div>
      </div>
    </div>
  );
}

function Watchlist({ data } :any) {

  const [watchlistData, setWatchlistData] = useState(data.data);
  const [confirmDelete, setConfirmDelete] = useState<{ isOpen: boolean; ticker: string | null; item: any | null }>({
    isOpen: false,
    ticker: null,
    item: null,
  });

  function updateWatchlistAPI(ticker) {
    const url = "/watchlists/" + data.id + "/watchlist_item/" + ticker;
    const msg = fetch(url, {method: 'DELETE'})
      .then(resp => resp.json)

    return msg;
  }

  function updateWatchlist(e, item) {
    if (e) {
      e.preventDefault();
    }
    const watchlist = watchlistData.filter(i => i.ticker !== item.ticker)
    updateWatchlistAPI(item.ticker)
    return setWatchlistData(watchlist);
  }

  function truncate(str, n){
    return (str.length > n) ? str.substr(0, n-1) + '...' : str;
  };

  function recommendationClass(decision_color) {
    if (decision_color == 'red') {
      return 'recommendation-badge red'
    } else if (decision_color == 'green') {
      return 'recommendation-badge green'
    } else {
      return 'recommendation-badge blue'
    }
  }

  function tableRowClass(decision_color) {
    if (decision_color == 'red') {
      return 'table-row red-row'
    } else if (decision_color == 'green') {
      return 'table-row green-row'
    } else if (decision_color == 'blue') {
      return 'table-row blue-row'
    } else {
      return 'table-row gray-row'
    }
  }

  function getChangeIcon(changePercent) {
    if (!changePercent) return null;
    const isPositive = changePercent.includes('+') || parseFloat(changePercent) > 0;
    return isPositive ? '↗' : '↘';
  }

  return (
    <div className="watchlist-container">
      <style>{`
        .watchlist-container {
          min-height: 100vh;
          background: linear-gradient(135deg, #f8fafc 0%, #eff6ff 100%);
        }

        .watchlist-header {
          background: #ffffff;
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
          border-bottom: 1px solid #e5e7eb;
        }

        .header-content {
          max-width: 80rem;
          margin: 0 auto;
          padding: 1.5rem 1rem;
        }

        .header-flex {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .header-title {
          font-size: 1.875rem;
          font-weight: 700;
          color: #111827;
          margin-bottom: 0.5rem;
        }

        .breadcrumb {
          display: flex;
          align-items: center;
        }

        .breadcrumb ol {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          list-style: none;
          margin: 0;
          padding: 0;
        }

        .breadcrumb li {
          display: flex;
          align-items: center;
        }

        .breadcrumb a {
          color: #6b7280;
          text-decoration: none;
          transition: color 0.15s;
        }

        .breadcrumb a:hover {
          color: #2563eb;
        }

        .breadcrumb .separator {
          width: 1rem;
          height: 1rem;
          color: #9ca3af;
          margin: 0 0.5rem;
        }

        .breadcrumb .current {
          color: #2563eb;
          font-weight: 500;
        }

        .item-counter {
          background-color: #dbeafe;
          color: #1e40af;
          padding: 0.5rem 1rem;
          border-radius: 9999px;
          font-size: 0.875rem;
          font-weight: 500;
        }

        .main-content {
          max-width: 80rem;
          margin: 0 auto;
          padding: 2rem 1rem;
        }

        .watchlist-card {
          background: #ffffff;
          border-radius: 1rem;
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
          border: 1px solid #f3f4f6;
          overflow: hidden;
        }

        .card-header {
          background: linear-gradient(to right, #f9fafb, #f3f4f6);
          padding: 1rem 1.5rem;
          border-bottom: 1px solid #e5e7eb;
        }

        .card-title {
          font-size: 1.25rem;
          font-weight: 600;
          color: #111827;
          margin: 0;
        }

        .card-subtitle {
          color: #4b5563;
          margin-top: 0.25rem;
          margin-bottom: 0;
        }

        .table-container {
          overflow-x: auto;
        }

        .watchlist-table {
          width: 100%;
          border-collapse: collapse;
        }

        .watchlist-table th {
          background-color: #f9fafb;
          padding: 1rem 1.5rem;
          text-align: left;
          font-size: 0.75rem;
          font-weight: 600;
          color: #374151;
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }

        .watchlist-table td {
          padding: 1rem 1.5rem;
          white-space: nowrap;
          border-bottom: 1px solid #f3f4f6;
        }

        .table-row {
          transition: background-color 0.15s;
        }

        .table-row:hover {
          background-color: #f3f4f6 !important;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        .red-row {
          border-left: 4px solid #ef4444;
          background-color: rgba(254, 242, 242, 0.3);
        }

        .red-row:hover {
          background-color: rgba(254, 242, 242, 0.8) !important;
        }

        .green-row {
          border-left: 4px solid #22c55e;
          background-color: rgba(220, 252, 231, 0.3);
        }

        .green-row:hover {
          background-color: rgba(220, 252, 231, 0.8) !important;
        }

        .blue-row {
          border-left: 4px solid #3b82f6;
          background-color: rgba(219, 234, 254, 0.3);
        }

        .blue-row:hover {
          background-color: rgba(219, 234, 254, 0.8) !important;
        }

        .gray-row {
          border-left: 4px solid #6b7280;
          background-color: rgba(249, 250, 251, 0.3);
        }

        .gray-row:hover {
          background-color: rgba(249, 250, 251, 0.8) !important;
        }

        .ticker-badge {
          display: inline-flex;
          align-items: center;
          padding: 0.25rem 0.75rem;
          border-radius: 9999px;
          font-size: 0.875rem;
          font-weight: 600;
          background-color: #dbeafe;
          color: #1e40af;
          text-decoration: none;
          transition: background-color 0.15s;
        }

        .ticker-badge:hover {
          background-color: #bfdbfe;
        }

        .ticker-icon {
          width: 0.75rem;
          height: 0.75rem;
          margin-left: 0.25rem;
        }

        .recommendation-badge {
          display: inline-flex;
          align-items: center;
          padding: 0.125rem 0.625rem;
          border-radius: 9999px;
          font-size: 0.75rem;
          font-weight: 500;
          border: 1px solid;
        }

        .recommendation-badge.red {
          background-color: #fee2e2;
          color: #991b1b;
          border-color: #fecaca;
        }

        .recommendation-badge.green {
          background-color: #dcfce7;
          color: #166534;
          border-color: #bbf7d0;
        }

        .recommendation-badge.blue {
          background-color: #dbeafe;
          color: #1e40af;
          border-color: #bfdbfe;
        }

        .change-indicator {
          display: flex;
          align-items: center;
          gap: 0.25rem;
        }

        .change-icon {
          font-size: 1.125rem;
        }

        .change-value {
          font-size: 0.875rem;
          font-weight: 600;
        }

        .progress-container {
          display: flex;
          align-items: center;
        }

        .progress-bar {
          width: 4rem;
          background-color: #e5e7eb;
          border-radius: 9999px;
          height: 0.5rem;
          margin-right: 0.5rem;
        }

        .progress-fill {
          height: 0.5rem;
          border-radius: 9999px;
          background: linear-gradient(to right, #4ade80, #3b82f6);
          transition: width 0.3s;
        }

        .progress-value {
          font-size: 0.875rem;
          font-weight: 600;
          color: #111827;
        }

        .delete-button {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 2rem;
          height: 2rem;
          border-radius: 9999px;
          background-color: #fee2e2;
          color: #dc2626;
          border: none;
          cursor: pointer;
          transition: background-color 0.15s;
        }

        .delete-button:hover {
          background-color: #fecaca;
        }

        .delete-icon {
          width: 1rem;
          height: 1rem;
        }

        .empty-state {
          background: #ffffff;
          border-radius: 1rem;
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
          border: 1px solid #f3f4f6;
          padding: 3rem 2rem;
          text-align: center;
        }

        .empty-content {
          max-width: 28rem;
          margin: 0 auto;
        }

        .empty-icon {
          width: 6rem;
          height: 6rem;
          background-color: #f3f4f6;
          border-radius: 9999px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1.5rem;
        }

        .empty-icon svg {
          width: 3rem;
          height: 3rem;
          color: #9ca3af;
        }

        .empty-title {
          font-size: 1.25rem;
          font-weight: 600;
          color: #111827;
          margin-bottom: 0.5rem;
        }

        .empty-description {
          color: #4b5563;
          margin-bottom: 1.5rem;
        }

        .browse-button {
          display: inline-flex;
          align-items: center;
          padding: 0.75rem 1.5rem;
          border: 1px solid transparent;
          font-size: 1rem;
          font-weight: 500;
          border-radius: 0.5rem;
          color: #ffffff;
          background-color: #2563eb;
          text-decoration: none;
          transition: background-color 0.15s;
        }

        .browse-button:hover {
          background-color: #1d4ed8;
        }

        .browse-icon {
          width: 1rem;
          height: 1rem;
          margin-left: 0.5rem;
        }

        .company-name {
          font-size: 0.875rem;
          font-weight: 500;
          color: #111827;
        }

        .decision-text {
          font-size: 0.875rem;
          color: #111827;
          font-weight: 500;
        }

        .price-text {
          font-size: 0.875rem;
          font-weight: 600;
        }

        .safety-text {
          font-size: 0.875rem;
          color: #111827;
        }

        .payback-text {
          font-size: 0.875rem;
          color: #111827;
        }

        /* Confirmation Dialog Styles */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }

        .modal-content {
          background-color: white;
          padding: 2rem;
          border-radius: 0.75rem;
          max-width: 28rem;
          width: 90%;
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
        }

        .modal-content h3 {
          font-size: 1.25rem;
          font-weight: 600;
          color: #111827;
          margin: 0 0 1rem 0;
        }

        .modal-content p {
          color: #4b5563;
          margin: 0 0 1.5rem 0;
          line-height: 1.5;
        }

        .confirmation-actions {
          display: flex;
          justify-content: flex-end;
          gap: 0.75rem;
        }

        .btn {
          padding: 0.5rem 1rem;
          border-radius: 0.375rem;
          font-size: 0.875rem;
          font-weight: 500;
          border: none;
          cursor: pointer;
          transition: background-color 0.15s;
        }

        .btn-secondary {
          background-color: #6b7280;
          color: white;
        }

        .btn-secondary:hover {
          background-color: #4b5563;
        }

        .btn-danger {
          background-color: #dc2626;
          color: white;
        }

        .btn-danger:hover {
          background-color: #b91c1c;
        }
      `}</style>

      {/* Header Section */}
      <div className="watchlist-header">
        <div className="header-content">
          <div className="header-flex">
            <div>
              <h1 className="header-title">{data.name}</h1>
              <nav className="breadcrumb" aria-label="Breadcrumb">
                <ol>
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>
                    <svg className="separator" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                    </svg>
                    <a href="/dashboard">Dashboard</a>
                  </li>
                  <li>
                    <svg className="separator" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="current">Watchlist</span>
                  </li>
                </ol>
              </nav>
            </div>
            <div className="item-counter">
              {watchlistData.length} {watchlistData.length === 1 ? 'Item' : 'Items'}
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="main-content">
        {watchlistData.length > 0 ? (
          <div className="watchlist-card">
            {/* Table Header */}
            <div className="card-header">
              <h2 className="card-title">Watchlist Items</h2>
              <p className="card-subtitle">Track your investment opportunities and decisions</p>
            </div>

            {/* Responsive Table */}
            <div className="table-container">
              <table className="watchlist-table">
                <thead>
                  <tr>
                    <th>Ticker</th>
                    <th>Company</th>
                    <th>Consideration</th>
                    <th>Decision</th>
                    <th>Price</th>
                    <th>Change</th>
                    <th>Margin of Safety</th>
                    <th>Payback Time</th>
                    <th>Value Score</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {watchlistData?.map((item, index) => (
                    <tr
                      key={index}
                      className={tableRowClass(item.default_valuation?.recommendation_color)}
                    >
                      <td>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={item.url}
                          className="ticker-badge"
                        >
                          {item.ticker}
                          <svg className="ticker-icon" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
                            <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
                          </svg>
                        </a>
                      </td>
                      <td>
                        <div className="company-name">
                          {truncate(item.company, 20)}
                        </div>
                      </td>
                      <td>
                        <span className={recommendationClass(item.default_valuation?.recommendation_color)}>
                          {item.default_valuation?.recommendation}
                        </span>
                      </td>
                      <td>
                        <div className="decision-text">
                          {item.default_valuation?.decision}
                        </div>
                      </td>
                      <td>
                        <div className="price-text" style={{ color: item.quote?.change_percent_color }}>
                          {item.default_valuation?.price_in_words}
                        </div>
                      </td>
                      <td>
                        <div className="change-indicator">
                          <span className="change-icon">{getChangeIcon(item.quote?.change_percent)}</span>
                          <span
                            className="change-value"
                            style={{ color: item.quote?.change_percent_color }}
                          >
                            {item.quote?.change_percent}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div className="safety-text">
                          {item.default_valuation?.margin_of_safety_in_words}
                        </div>
                      </td>
                      <td>
                        <div className="payback-text">
                          {item.default_valuation?.payback_time?.current_payback_time}
                        </div>
                      </td>
                      <td>
                        <div className="progress-container">
                          <div className="progress-bar">
                            <div
                              className="progress-fill"
                              style={{ width: `${item.value_score}%` }}
                            ></div>
                          </div>
                          <span className="progress-value">{item.value_score}%</span>
                        </div>
                      </td>
                      <td>
                        <Tooltip
                          title={`Remove ${item.ticker}`}
                          placement="bottom"
                          arrow
                        >
                          <button
                            onClick={(e) => {
                              setConfirmDelete({ isOpen: true, ticker: item.ticker, item: item });
                            }}
                            className="delete-button"
                          >
                            <svg className="delete-icon" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
                            </svg>
                          </button>
                        </Tooltip>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <div className="empty-state">
            <div className="empty-content">
              <div className="empty-icon">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                </svg>
              </div>
              <h3 className="empty-title">Your watchlist is empty</h3>
              <p className="empty-description">Start building your watchlist by adding stocks you're interested in tracking.</p>
              <a
                href="/"
                className="browse-button"
              >
                Browse Stocks
                <svg className="browse-icon" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </a>
            </div>
          </div>
        )}
      </div>

      {/* Confirmation Dialog */}
      {confirmDelete.isOpen && (
        <ConfirmationDialog
          isOpen={confirmDelete.isOpen}
          onConfirm={() => {
            updateWatchlist(null, confirmDelete.item);
            setConfirmDelete({ isOpen: false, ticker: null, item: null });
          }}
          onCancel={() => setConfirmDelete({ isOpen: false, ticker: null, item: null })}
          ticker={confirmDelete.ticker}
        />
      )}
    </div>
  );
}

export default Watchlist;
